<div class="app-view-receipt-dialog">
  <div class="header">
    <h3>Receipt</h3>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="content">
    <!-- Receipt Summary -->
    <div class="receipt-summary">
      <div class="network-branding">
        @if (data?.networkLogo) {
          <img [src]="data?.networkLogo" [alt]="data?.networkName" class="network-logo" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'" />
          <div class="network-logo-fallback" style="display: none;">
            <mat-icon>ev_station</mat-icon>
          </div>
        } @else {
          <div class="network-logo-fallback">
            <mat-icon>ev_station</mat-icon>
          </div>
        }
      </div>
      <h2 class="provider-name">{{ data?.networkName || 'Charging Network' }}</h2>
      <div class="receipt-amount">{{ data?.totalAmount | currency }}</div>
      <div class="receipt-date">{{ data?.date | date:'MMMM d, y' }}</div>
      <span class="status-badge" [ngClass]="getStatusClass(data?.status || '')">
        {{ data?.status }}
      </span>
    </div>

    <!-- Location Details -->
    <div class="receipt-section">
      <h4 class="section-title">Location Details</h4>
      <div class="receipt-row">
        <span class="label">Charger Location</span>
        <span class="value">{{ data?.locationName || '-' }}</span>
      </div>
      <div class="receipt-row">
        <span class="label">Address</span>
        <span class="value">
          @if (data?.stationId) {
            <a [routerLink]="['/station', data?.stationId]" target="_blank">
              {{ data?.address || '-' }}
            </a>
          } @else {
            {{ data?.address || '-' }}
          }
        </span>
      </div>
      <div class="receipt-row">
        <span class="label">Station ID</span>
        <span class="value">{{ data?.stationId || '-' }}</span>
      </div>
      <div class="receipt-row">
        <span class="label">Connector Number</span>
        <span class="value">{{ data?.connectorNumber || '-' }}</span>
      </div>
      <div class="receipt-row">
        <span class="label">Session ID</span>
        <span class="value">{{ data?.sessionId || '-' }}</span>
      </div>
    </div>

    <!-- Charging Details -->
    <div class="receipt-section">
      <h4 class="section-title">Charging Details</h4>
      <div class="receipt-row">
        <span class="label">Total Charge Time</span>
        <span class="value">{{ data ? formatDuration(data.durationMinutes) : '-' }}</span>
      </div>
      <div class="receipt-row">
        <span class="label">Energy Delivered</span>
        <span class="value">{{ data?.energyKwh | number:'1.2-2' }} kWh</span>
      </div>
      <div class="receipt-row">
        <span class="label">Power Type</span>
        <span class="value">{{ data?.powerType || '-' }}</span>
      </div>
      <div class="receipt-row">
        <span class="label">Max Power</span>
        <span class="value">{{ data?.maxPower || '-' }} kW</span>
      </div>
    </div>

    <!-- Payment Breakdown -->
    <div class="receipt-section payment-section">
      <h4 class="section-title">Payment Summary</h4>
      <div class="receipt-row">
        <span class="label">Charging Fees</span>
        <span class="value">{{ data?.chargingFee | currency }}</span>
      </div>
      <div class="receipt-row">
        <span class="label">Tax</span>
        <span class="value">{{ data?.tax | currency }}</span>
      </div>
      <div class="receipt-row total-row">
        <span class="label">Total Amount</span>
        <span class="value">{{ data?.totalAmount | currency }}</span>
      </div>
    </div>

    <!-- Footer -->
    <div class="receipt-footer">
      <span>Powered by GitCharger</span>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div class="actions">
    <button mat-button type="button" (click)="close()">Close</button>
    <button mat-flat-button type="button" class="download-button">
      <mat-icon>download</mat-icon>
      Download
    </button>
  </div>
</div>
